export default "__VITE_ASSET__BPvGMZ1C__"